import { Label, FormGroup, Select } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { rowsPerPageOptions } from '../../constants';
import { setVisitsFilters } from '../../actions';
import usePagination from '../Paginator/hooks';

const RowCountSelector = () => {
  const { pageSize } = usePagination();
  const dispatchSetVisitFilters = useAction(setVisitsFilters);
  const toNumber = value => parseInt(value, 10);
  const selectedSize = pageSize.toString();

  return (
    <FormGroup inline>
      <Label for="visits_rowsPerPage" size="sm">
        Show:
      </Label>
      <Select
        id="visits_rowsPerPage"
        value={selectedSize}
        size="sm"
        options={rowsPerPageOptions}
        onChange={event =>
          dispatchSetVisitFilters({ pageNumber: 1, pageSize: toNumber(event.target.value) })
        }
      />
    </FormGroup>
  );
};

export default RowCountSelector;
